import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { ArrowLeft, Newspaper, Download, Mail, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Press() {
  const { t } = useTranslation();

  const pressReleases = [
    {
      date: "January 15, 2026",
      title: "Listo Market Launches Global Expansion",
      excerpt: "The leading local marketplace announces expansion into 50 new countries...",
      source: "Business Wire"
    },
    {
      date: "December 10, 2025",
      title: "Series B Funding Secured to Enhance Safety Features",
      excerpt: "Investment led by TopTier Ventures will focus on AI-driven content moderation...",
      source: "TechCrunch"
    },
    {
      date: "November 5, 2025",
      title: "New 'Wanted Items' Feature Revolutionizes Local Search",
      excerpt: "Users can now broadcast their needs to local sellers with demand signals...",
      source: "Product Hunt"
    }
  ];

  const mentions = [
    { outlet: "The Verge", quote: "The safest way to buy and sell locally in 2026." },
    { outlet: "Forbes", quote: "One of the top 10 marketplaces to watch this year." },
    { outlet: "Wired", quote: "Finally, a platform that takes user verification seriously." }
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <nav className="border-b border-border sticky top-0 z-50 bg-background/95 backdrop-blur">
        <div className="container flex items-center justify-between h-16">
          <Link href="/">
            <a className="text-2xl font-bold gradient-text">{t('common.appName')}</a>
          </Link>
          <div className="flex items-center gap-4">
            <Link href="/">
              <a className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
                <ArrowLeft className="w-4 h-4" />
                {t('common.back')}
              </a>
            </Link>
            <LanguageSwitcher />
          </div>
        </div>
      </nav>

      <main className="flex-1">
        <section className="py-20 bg-muted/30">
          <div className="container text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Newsroom
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
              Analysis, updates, and announcements from the Listo Market team.
            </p>
            <div className="flex gap-4 justify-center">
              <Button>
                <Download className="w-4 h-4 mr-2" />
                Download Media Kit
              </Button>
              <Button variant="outline">
                <Mail className="w-4 h-4 mr-2" />
                Contact Press Team
              </Button>
            </div>
          </div>
        </section>

        <section className="py-16 container">
          <h2 className="text-2xl font-bold mb-8 flex items-center gap-2">
            <Newspaper className="w-6 h-6" />
            Recent Press Releases
          </h2>
          <div className="grid gap-6 md:grid-cols-3">
            {pressReleases.map((pr, i) => (
              <div key={i} className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
                <div className="text-sm text-muted-foreground mb-2">{pr.date} • {pr.source}</div>
                <h3 className="font-semibold text-lg mb-2">{pr.title}</h3>
                <p className="text-muted-foreground text-sm mb-4">{pr.excerpt}</p>
                <a href="#" className="text-primary text-sm font-medium flex items-center hover:underline">
                  Read More <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </div>
            ))}
          </div>
        </section>

        <section className="py-16 bg-muted/30">
          <div className="container">
            <h2 className="text-2xl font-bold mb-8 text-center">Featured In</h2>
            <div className="grid gap-8 md:grid-cols-3 text-center">
              {mentions.map((m, i) => (
                <div key={i} className="space-y-4">
                  <div className="text-2xl font-serif font-bold text-muted-foreground/50">{m.outlet}</div>
                  <blockquote className="text-lg italic">"{m.quote}"</blockquote>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
